<template>
    <div></div>
</template>

<script>
    import { Capacitor } from '@capacitor/core'

    export default {
        name: 'UserIndex',
        created(){

          if (Capacitor.platform === 'web') {
            console.log("___________________cookiebot init")
            this.$cookiebot.consentBanner()
          }

            // wait for user
            this.$store.dispatch('USER_REQUEST').then(() => {
                let role = this.$store.getters.getRole;

                // redirect users to their home pages
                if(role === 'user1' || role === 'user3'){
                    this.$router.push({ name: 'ChallangeIndex' })
                }
                if(role === 'user2'){
                    this.$router.push({ name: 'SpecialsIndex' })
                }
                if(role === 'salesman'){
                    this.$router.push({ name: 'ReportIndex'})
                }
            });
        }
    }
</script>